import { createStore, combineReducers, applyMiddleware } from 'redux';
import { reducer as formReducer } from 'redux-form';
import {
  uiReducer, dashboardReducer, familyMembersReducer, nutritionReducer,
  authReducer, bookingsReducer, paymentReducer, deepLinkParamaters, trackingReducer,
  summaryDashboardReducer, LOGOUT, plannerReducer, RESET_APP_STATE, weightTargetReducer,
  strengthAssessmentReducer,
} from 'fitbeat.react-native-components';
import {
  HeartRateMonitor as heartRateMonitorReducer,
} from 'fitbeat.react-native-components/HomeWorkouts';
import thunk from 'redux-thunk';

const appReducer = combineReducers({
  ui: uiReducer,
  form: formReducer,
  dashboard: dashboardReducer,
  nutrition: nutritionReducer,
  auth: authReducer,
  bookings: bookingsReducer,
  payments: paymentReducer,
  deepLinkParamaters,
  tracking: trackingReducer,
  summaryDashboard: summaryDashboardReducer,
  planner: plannerReducer,
  weightTarget: weightTargetReducer,
  familyMembers: familyMembersReducer,
  strengthAssessment: strengthAssessmentReducer,
  heartRateMonitor: heartRateMonitorReducer,
});

const rootReducer = (state, action) => {
  if (action.type === LOGOUT || action.type === RESET_APP_STATE) {
    state = undefined;
  }
  return appReducer(state, action);
};


const store = createStore(rootReducer, applyMiddleware(thunk));
export default store;
